import { ActionReducerMap } from '@ngrx/store';
import { RouterReducerState, routerReducer } from '@ngrx/router-store';
import * as fromAuthentication from '../authentication/store/authentication.reducer';
import * as fromSpaProjects from '../spa/store/spa-project.reducer';
import * as fromCore from '../core/store/core.reducer';
import * as fromUser from '../users/store/user.reducer';
import * as fromPermission from '../permissions/store/permission.reducer';
import * as fromCustomers from '../customers/store/customers.reducer';
import * as fromUI from '../ui/store/ui.reducer';
import * as fromProjectLabels from '../validation/store/project-labels/project-labels.reducer';
import * as fromProjectFilters from '../spa/store/project-filters/project-filters.reducer';
import * as fromDashboard from '../dashboard/store/dashboard.reducer';
import * as fromDiscrepancies from '../discrepancies/store/discrepancies.reducer';
import * as fromParameter from '../parameters/store/parameter.reducer';
import * as fromCheck from '../checks/store/check.reducer';
import * as fromStatus from '../statuses/store/status.reducer';
import * as fromCompare from '../discrepancies/store/compare/compare.reducer';
import * as fromTabs from '../discrepancies/store/tabs/tabs.reducer';
import * as fromTasks from '../discrepancies/store/tasks/tasks.reducer';
import * as fromTaskDesigner from '../discrepancies/store/task-designer/task-designer.reducer';
import * as fromTracker from '../tracker/store/tracker.reducer';
import * as fromAlgoSettings from '../algo-settings/store/algo-settings.reducer';
import * as fromValidation from '../validation/store/validation/validation.reducer';
import * as fromDesigner from '../task-designer/store/designer/designer.reducer';
import * as fromSettings from '../settings/store/settings.reducer';
import * as fromReportConfigurations from '../settings/store/report-configuration.reducer';
import * as fromOverview from '../overview/store/tasks-overview.reducer';
import * as fromExternalAccess from '../plugins/external-access/store/external-access.reducer';
export interface IAppState {
  router: RouterReducerState;
  authentication: fromAuthentication.State;
  spaProjects?: fromSpaProjects.State;
  core: fromCore.State;
  users: fromUser.State;
  customers: fromCustomers.State;
  ui: fromUI.State;
  projectLabels: fromProjectLabels.State;
  projectFilters: fromProjectFilters.State;
  dashboard: fromDashboard.State;
  discrepancies: fromDiscrepancies.State;
  parameters: fromParameter.State;
  checks: fromCheck.State;
  statuses: fromStatus.State;
  compare: fromCompare.State;
  tabs: fromTabs.State;
  permissions: fromPermission.State;
  tasks: fromTasks.State;
  taskDesigner: fromTaskDesigner.State;
  tracker: fromTracker.State;
  algoSettings: fromAlgoSettings.State;
  validation: fromValidation.State;
  designer: fromDesigner.State;
  settings: fromSettings.State;
  overview: fromOverview.State;
  externalAccess: fromExternalAccess.State;
  reportConfigurations: fromReportConfigurations.State;
}

export const reducers: ActionReducerMap<IAppState> = {
  router: routerReducer,
  authentication: fromAuthentication.reducer,
  spaProjects: fromSpaProjects.reducer,
  core: fromCore.reducer,
  users: fromUser.reducer,
  customers: fromCustomers.reducer,
  ui: fromUI.reducer,
  projectLabels: fromProjectLabels.reducer,
  projectFilters: fromProjectFilters.reducer,
  dashboard: fromDashboard.reducer,
  discrepancies: fromDiscrepancies.reducer,
  parameters: fromParameter.reducer,
  checks: fromCheck.reducer,
  statuses: fromStatus.reducer,
  compare: fromCompare.reducer,
  tabs: fromTabs.reducer,
  permissions: fromPermission.reducer,
  tasks: fromTasks.reducer,
  taskDesigner: fromTaskDesigner.reducer,
  tracker: fromTracker.reducer,
  algoSettings: fromAlgoSettings.reducer,
  validation: fromValidation.reducer,
  designer: fromDesigner.reducer,
  settings: fromSettings.reducer,
  overview: fromOverview.reducer,
  externalAccess: fromExternalAccess.reducer,
  reportConfigurations: fromReportConfigurations.reducer
};
